import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { BaseFilterInterface } from '../../interfaces/base-filter.interface';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { baseUserSelectors, BaseCoreState } from '../../../_store';
import { GroupListItemResponse } from '../../../../api';
import { PERMISSION_GROUP_FILTERS } from '../../../modules/administration/_constans/permission-group-filters.const';
import { BASE_ROLES } from '../../../core/constants/base-roles';
import { BaseRolesService } from '../../../core/services/base-roles.service';

@Component({
  selector: 'base-filter-buttons',
  templateUrl: './base-filter-buttons.component.html',
})
export class BaseFilterButtonsComponent implements OnInit, OnDestroy {
  @Input() filters: Array<BaseFilterInterface> = [];
  @Input() selectedClass = 'btn-primary';
  @Input() activeFilter: BaseFilterInterface;
  @Output() activeFilterUpdate = new EventEmitter<BaseFilterInterface>();

  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>, private rolesService: BaseRolesService) {}

  get isPSP() {
    return this.rolesService.isPsp();
  }

  ngOnInit(): void {
    this.store
      .select(baseUserSelectors.getUserGroups)
      .pipe(
        takeUntil(this.destroy$),
        map((state) => state.data as GroupListItemResponse[])
      )
      .subscribe((groups) => {
        this.filters = this.prepareGroupsForFilters(groups);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  setActiveFilter(event: Event, filter: BaseFilterInterface) {
    event.preventDefault();
    this.activeFilterUpdate.emit(filter);
  }

  private prepareGroupsForFilters(list: GroupListItemResponse[]): BaseFilterInterface[] {
    const groups: BaseFilterInterface[] = [...PERMISSION_GROUP_FILTERS];

    if (!this.isPSP) {
      groups.push({
        id: 'workCouncil',
        title: 'workCouncil.label',
        roles: [BASE_ROLES.CUSTOMER_WORK_COUNCIL],
      });
    }

    list.forEach((item) => {
      groups.push({
        id: item.id?.toString() as string,
        title: item.name as string,
        groupId: item.id,
        roles: [],
      });
    });

    return groups;
  }
}
